export default function Api (API_URL) {
  return {
    async getCards (lang) {
      const response = await fetch(`${API_URL}?lang=${lang}&per_page=100`)
      if (isJson(response)) {
        const posts = await response.json()
        return posts.map(post => ({
          id: post.id,
          title: post.title.rendered,
          description: post.acf.content,
          lang: post.lang,
          translations: post.translations,
        }))
      }
      throw new Error('Response is not json')
    },
  }
}

function isJson (response) {
  return response.headers.get('content-type').includes('application/json')
}
